import { Nulpunten } from "../../../../content/wiskunde/functies/nulpunten/drawings/plots.tsx";
import * as React from 'react';
export default {
  Nulpunten,
  React
};